import { PropsWithChildren } from 'react';
import { UnstyledButton, UnstyledButtonProps } from '@mantine/core';

type LegacyLinkButtonPropsType = PropsWithChildren<{
  href: string;
  className?: string;
}> &
  UnstyledButtonProps;

export const LegacyLinkButton: React.FC<LegacyLinkButtonPropsType> = ({
  href,
  children,
  className,
  ...props
}) => {
  return (
    <UnstyledButton
      component="a"
      className={className}
      href={`${process.env.PUBLIC_DREAMHAUS_URL}${href}`}
      onClick={(e) => e.stopPropagation()}
      {...props}
    >
      {children}
    </UnstyledButton>
  );
};
